function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M79.7,75.9c0,3.1-2.7,5.5-5.8,5.4h-3.5l4.7,10.4-16.7-10.4H25.3c-3,0-5.6-2.4-5.6-5.4v-30.8c0-2.9,2.5-5.3,5.5-5.2h48.7c3.2,0,5.8,2.3,5.8,5.2v30.8Z",
  fill: "none",
  stroke: "current",
  strokeMiterlimit: 10,
  strokeWidth: 3
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M1.5,27.1V94.4c0,3.4,2.7,6.1,6.1,6.1H93.2c3.4,0,6.1-2.7,6.1-6.1V35.8c0-3.3-2.7-6-6-6H50.4c-2.9,0-5.4-2.1-6.1-4.9-1.8-4.4-5.7-3.8-9.1-3.8H7.6c-3.4,0-6.1,2.7-6.1,6.1h0Z",
  fill: "none",
  stroke: "current",
  strokeMiterlimit: 10,
  strokeWidth: 3
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M84.1,33.6c9.2,0,16.8-7.6,16.8-16.8S93.3,0,84.1,0s-16.8,7.6-16.8,16.8h0c0,9.2,7.4,16.8,16.8,16.8h0Z",
  fill: "current"
});
var _ref5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
  x1: 84.1,
  y1: 6.8,
  x2: 84.1,
  y2: 26.8,
  fill: "none",
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("line", {
  x1: 93.9,
  y1: 16.8,
  x2: 74,
  y2: 16.8,
  fill: "none",
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: 3
}));
function SvgAddprojectDeactivated(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_7",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100.9 102",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddprojectDeactivated);
export default __webpack_public_path__ + "static/media/Add project-deactivated.7ad0dac7.svg";
export { ForwardRef as ReactComponent };